import { render } from "./WireframesHomePage.vue?vue&type=template&id=13093852&scoped=true"
import script from "./WireframesHomePage.vue?vue&type=script&lang=js"
export * from "./WireframesHomePage.vue?vue&type=script&lang=js"

import "./WireframesHomePage.vue?vue&type=style&index=0&id=13093852&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13093852"]])

export default __exports__